import * as React from 'react';
import { createSvg } from '../../utils/createSvg';
export var WarningFilledSmall = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M8 12.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM7.25 4a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0V4ZM8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Z" })), '0 0 16 16', 'WarningFilledSmall');
//# sourceMappingURL=WarningFilledSmall.js.map